import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
// import { Col, Row } from 'react-bootstrap';
// import OwlCarousel from 'react-owl-carousel';
// import { useSelector } from 'react-redux';
const Carousels = () => {
    // const movies = useSelector(state => state.MovieHomePage.Movie.movies);
    // console.log(movies);
    return (
        <div>
            {/* <Row>
                <OwlCarousel className="owl-theme owl-slider" items={1} loop autoplay={true} nav dots={false}>
                    {
                        movies && movies?.map((Movies, index) => {
                            return (
                                <Col className="p-1" key={index}>
                                    <div className="item">
                                        <figure>
                                            <img className="rounded" src={Movies.background_image} alt="thumbnail" />
                                        </figure>
                                    </div>
                                </Col>
                            )
                        })
                    }
                </OwlCarousel>
            </Row> */}
            <Carousel>
                <Carousel.Item>
                    <img
                        className="d-block w-100 rounded"
                        src={process.env.PUBLIC_URL+ "slide1.jpg"}
                        alt="Slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100 rounded"
                        src={process.env.PUBLIC_URL+ "slide2.jpg"}
                        alt="slide"
                    />
                </Carousel.Item>
                <Carousel.Item>
                    <img
                        className="d-block w-100 rounded"
                        src={process.env.PUBLIC_URL+ "slide3.jpg"}
                        alt="Third slide"
                    />
                </Carousel.Item>
            </Carousel>
        </div>
    );
}

export default Carousels;
